export namespace ReadMoreExcerpt {
	let setupReadMore = () => {

		let excerpts = document.querySelectorAll('.js-read-more-excerpt');

		//iterate each excerpt and listen for clicks
		excerpts.forEach((excerpt, index) => {
			let toggle = excerpt.querySelector('.js-read-more-toggle');
			toggle.addEventListener('click', (e) => {
				e.preventDefault();
				excerpt.classList.toggle('show');
			});
		});
	}

	export const init = () => {
		setupReadMore();
	}
}

document.addEventListener('DOMContentLoaded', ReadMoreExcerpt.init);
